import styled from "styled-components"

export const HomeWrapper = styled.div`
.home_slide_img{
    margin-top: 32px;
}
.home_product{
    margin-bottom: 32px;
}
.home_container{
    position: relative;
}
.link_sticky{
    position: fixed;
    bottom: 100px;
    left: calc((100% - 1200px) / 2 - 70px);
    span{
        display: block;
        &:hover{
            transform: translateY(-10px);
            transition: all .3s linear;
        }
    }
}

`